import React, { useEffect, useRef, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import moment from 'moment';
import Swal from 'sweetalert2';
import { generateAxiosInstanceSection } from '../../hooks/useAuthorizedRequestForSection';
import { generateAxiosInstanceStudent } from '../../hooks/useAuthorizedRequestForStudent';
import { CModal } from '@coreui/react';
import { useNavigate } from 'react-router-dom';
import VidyaUpasna from "../../assets/VidyaUpasna.jpg";
import { GeneratePdf } from '../../components/GeneratePdf';
import { Loader } from '../../components/ModalsCommonFunctions';
import separator_line from "../../assets/separator_line.png";
import { getCurrentTime } from '../../components/CurrentTime';
import { findPageNumber, searchArray, SortIcon } from '../../components/Navigation';
import Pagination from '../../components/Pagination';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { TextField } from '@mui/material';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

const ExamDetails = () => {
    const sectionMasterId = localStorage.getItem("sectionMasterId")
    const authorizedAxiosSection = generateAxiosInstanceSection()
    const authorizedAxiosStudent = generateAxiosInstanceStudent()
    const isMulti = useRef("N");
    const examType = useRef(null);
    const [visibleView, setVisibleView] = useState()
    const [visibleResult, setVisibleResult] = useState();
    const [visibleLeaderBoard, setVisibleLeaderBoard] = useState();
    const [examNameList, setExamNameList] = useState([]);
    const [examDetails, setExamDetails] = useState([]);
    const [leaderBoardDetails, setLeaderBoardDetails] = useState(null);
    const [selectedExam, setSelectedExam] = useState()
    const [showPassword, setShowPassword] = useState(false);
    const [showReExamPassword, setShowReExamPassword] = useState(false);
    const [month, setMonth] = useState(moment().format('YYYY-MM'));
    const [start_date, setStartDate] = useState(moment().startOf('month').format('YYYY-MM-DD'));
    const [end_date, setEndDate] = useState(moment().endOf('month').format('YYYY-MM-DD'));

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);

    const [examNameSort, setExamNameSort] = useState(null);
    const [examDateSort, setExamDateSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = [
        "ExamMaster.exam_name",
        "exam_mode",
        "startdate_24hrs",
        "InstituteGradeMaster.gradeName",
        "ExamMaster.uploadPdfExamSubjects.subjectMaster.subjectName",
        "ExamMaster.subjectMaster.subjectName",
        "ExamMaster.instituteSubjectMaster.subjectName",
        "ExamMaster.ExamUploadQuestion.subjectMaster.subjectName",
        "ExamMaster.ExamUploadQuestion.instituteSubjectMaster.subjectName",
        "ExamMaster.ExamMasterQuestions.subjectMaster.subjectName",
        "ExamMaster.ExamMasterQuestions.instituteSubjectMaster.subjectName"
    ];


    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    const togglePasswordVisibility = () => {
        setShowPassword(prevState => !prevState);
    };

    const toggleReExamPasswordVisibility = () => {
        setShowReExamPassword(prevState => !prevState);
    };

    useEffect(() => {
        getExamMasterList()
    }, [month]);

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            getExamMasterList();
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value.trim()); // Only set the trimmed value
    };

    const handleSearch = async () => {
        if (searchValue !== null) {
            // Map searchValue to a numerical value if it matches specific conditions
            let processedSearchValue;
            if (searchValue === "Offline") processedSearchValue = "1";
            else if (searchValue === "Online") processedSearchValue = "2";
            else if (searchValue === "Both (Offline + Online)") processedSearchValue = "3";
            else processedSearchValue = searchValue;

            setExamNameList(
                await searchArray("B", `/assigned-exams?section_id=${sectionMasterId}&start_date=${start_date}&end_date=${end_date}`, searchKeys, processedSearchValue, "data")
            );
        }
    };

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(examNameList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId])

    useEffect(() => {
        setTotalPages(Math.ceil(examNameList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > examNameList.length) {
            endIndex = examNameList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(examNameList.slice(startIndex, endIndex));
    }, [examNameList, currPage, itemsPerPage]);

    // const getExamMasterList = () => {
    //     setLoading(true);
    //     const apiUrl2 = `assigned-exams?section_id=${sectionMasterId}`;
    //     authorizedAxiosSection && authorizedAxiosSection.get(apiUrl2)
    //         .then(response => {
    //             setExamNameList(response.data.data)
    //         })
    //         .catch(error => {
    //             const errorMsg = error?.response?.data?.message || 'Something went wrong!';
    //             console.error('Error fetching data:', errorMsg);
    //         })
    //         .finally(() => {
    //             setLoading(false); // End loading
    //         });
    // }

    const handleMonth = (newMonth) => {
        setMonth(newMonth ? newMonth.format('YYYY-MM') : '');
        setStartDate(newMonth.startOf('month').format('YYYY-MM-DD'));
        setEndDate(newMonth.endOf('month').format('YYYY-MM-DD'));
    };

    const getExamMasterList = async () => {
        const apiUrl2 = `/assigned-exams?section_id=${sectionMasterId}&start_date=${start_date}&end_date=${end_date}`;

        try {
            const response = await authorizedAxiosSection.get(apiUrl2);
            setExamNameList(response.data.data);
        } catch (error) {
            setExamNameList([])
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        }
    };


    const handleExamDetails = (id, multiSubject, exam_type, is_competitive) => {
        setLoading(true);
        isMulti.current = multiSubject;
        examType.current = exam_type;
        const apiUrl = (multiSubject === "Y" /*&& is_competitive != "Y"*/ && (exam_type === "M" || exam_type === "U")) ? `get-multiple-subject-exam-wise-result?exam_id=${id}` : `/get-exam-wise-result?exam_id=${id}`;
        // const apiUrl = `/get-exam-wise-result?exam_id=${id}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
            .then(response => {
                setExamDetails(response.data)
                setVisibleResult(!visibleResult)
            })
            .catch(error => {
                setExamDetails([])
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire({
                    text: errorMsg
                })
            })
            .finally(() => {
                setLoading(false); // End loading
            });
    }

    const handleLeaderBoard = (id) => {
        setLoading(true);
        const apiUrl = `/exams-leaderboard-v2?exam_id=${id}`;
        authorizedAxiosStudent && authorizedAxiosStudent.get(apiUrl)
            .then(response => {
                setLeaderBoardDetails(response.data.leaderboard)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            })
            .finally(() => {
                setLoading(false); // End loading
            });
    }

    const getSubjectNames = (exam) => {
        // Check if the exam is a PDF exam
        if (exam?.is_pdf_exam === "Y") {
            const pdfExamSubjectNames = [
                ...new Set(
                    exam?.uploadPdfExamSubjects?.map(q => q.subjectMaster?.subjectName).filter(Boolean)
                )
            ];

            // Return unique subject names from uploadPdfExamSubjects if found
            if (pdfExamSubjectNames.length > 0) {
                return pdfExamSubjectNames.join(", ");
            }
        }

        const subjectName = exam?.is_competitive === 'Y'
            ? (
                exam?.competitive_exam_type === "A"
                    ? exam?.subjectMaster?.subjectName
                    : exam?.instituteSubjectMaster?.subjectName
            )
            : (
                exam?.syllabus_structure_type === "A"
                    ? exam?.subjectMaster?.subjectName
                    : exam?.instituteSubjectMaster?.subjectName
            );

        // If subjectName is not null, return it
        if (subjectName) {
            return subjectName;
        }

        // Check for subject names in ExamUploadQuestion if subjectName is null
        const uploadQuestionSubjectNames = [
            ...new Set(
                exam?.ExamUploadQuestion.map(q =>
                    q.subjectMaster?.subjectName || q.instituteSubjectMaster?.subjectName
                ).filter(Boolean)
            )
        ];

        // If subject names found in ExamUploadQuestion, return them
        if (uploadQuestionSubjectNames.length > 0) {
            return uploadQuestionSubjectNames.join(", ");
        }

        // Check for subject names in ExamMasterQuestions if still null
        const masterQuestionSubjectNames = [
            ...new Set(
                exam?.ExamMasterQuestions.map(q =>
                    q.subjectMaster?.subjectName || q.instituteSubjectMaster?.subjectName
                ).filter(Boolean)
            )
        ];

        // If subject names found in ExamMasterQuestions, return them
        if (masterQuestionSubjectNames.length > 0) {
            return masterQuestionSubjectNames.join(", ");
        }

        // Default fallback message if no subject names found
        return "No subjects available";
    }

    useEffect(() => {
        if (examNameSort == true || examNameSort == false) {
            setExamDateSort(null);
        }
    }, [examNameSort])

    useEffect(() => {
        if (examDateSort == true || examDateSort == false) {
            setExamNameSort(null);
        }
    }, [examDateSort])

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/section-dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Exam Deatils</span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-pen"></i>Exam Details</b></h4>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-12 full_wrap">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Month</label>
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DatePicker
                                                            views={['year', 'month']}
                                                            value={dayjs(month)}
                                                            onChange={handleMonth}
                                                            renderInput={(params) => <TextField {...params} />}
                                                        />
                                                    </LocalizationProvider>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="d-grid gap-2 mt-2">
                                            <div class="tab-content rounded-bottom custom_table">
                                                <div className='search_btn_row'>
                                                    <input
                                                        className="form-control mr-sm-2"
                                                        type="Search"
                                                        placeholder="Search"
                                                        value={searchValue}
                                                        onChange={handleEmptySearch}
                                                        onKeyDown={(event) => {
                                                            if (event.key === 'Enter') {
                                                                handleSearch();
                                                            }
                                                        }}
                                                    />
                                                    <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                </div>
                                                <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                    <table class="table">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col" className='sl_no'>Sr. No.</th>
                                                                <th scope="col">
                                                                    Exam Name
                                                                    <SortIcon sortState={examNameSort} setSortState={setExamNameSort} setData={setExamNameList} setCurrPage={setCurrPage} sortingPath={"ExamMaster.exam_name"} />
                                                                </th>
                                                                <th scope="col">Exam Mode</th>
                                                                <th scope="col">
                                                                    Start Date
                                                                    <SortIcon sortState={examDateSort} setSortState={setExamDateSort} setData={setExamNameList} setCurrPage={setCurrPage} sortingPath={"startdate_24hrs"} />
                                                                </th>
                                                                <th scope="col">Exam Created Class</th>
                                                                <th scope="col">Exam Assigned Class</th>
                                                                <th scope="col">Exam Subject</th>
                                                                <th scope="col">Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                displayedData?.length > 0 ?
                                                                    displayedData?.map((exam, index) => {
                                                                        return (
                                                                            <tr>
                                                                                <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                <td>{exam?.ExamMaster?.exam_name}</td>
                                                                                <td>{exam?.exam_mode === 1 ? "Offline" : exam?.exam_mode === 2 ? "Online" : exam?.exam_mode === 3 ? "Both (Offline + Online)" : ""}</td>
                                                                                <td>{exam?.startdate_24hrs?.split(" ")[0]}</td>
                                                                                <td>{exam?.ExamMaster?.InstituteGradeMaster?.gradeName}</td>
                                                                                <td>{exam?.InstituteGradeMaster?.gradeName}</td>

                                                                                <td>
                                                                                    {getSubjectNames(exam.ExamMaster)}
                                                                                    {/* {(exam?.ExamMaster?.is_competitive === 'Y' && exam?.ExamMaster?.competitive_exam_type === 'A') ||
                                                                                        (exam?.ExamMaster?.syllabus_structure_type === 'A')
                                                                                        ? exam?.ExamMaster?.subjectMaster?.subjectName
                                                                                        : exam?.ExamMaster?.instituteSubjectMaster?.subjectName} */}
                                                                                </td>
                                                                                <td>
                                                                                    <div className='btn_group'>
                                                                                        <button className='btn btn-success' onClick={() => { setSelectedExam(exam); setVisibleView(!visibleView) }}>View </button>
                                                                                        <button className='btn btn-success' onClick={() => { handleExamDetails(exam.exam_id, exam.ExamMaster.isMulti, exam.ExamMaster.exam_type, exam.ExamMaster.is_competitive) }}>Result </button>
                                                                                        <button className='btn btn-success' onClick={() => { handleLeaderBoard(exam.exam_id); setVisibleLeaderBoard(!visibleLeaderBoard) }}>LeaderBoard </button>
                                                                                    </div>
                                                                                </td>
                                                                            </tr>
                                                                        )
                                                                    })
                                                                    :
                                                                    (<tr>
                                                                        <th colspan={"100%"} style={{ textAlign: 'center' }}>No Exam Details Available</th>
                                                                    </tr>)
                                                            }
                                                        </tbody>
                                                    </table>
                                                    <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={examNameList.length} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />

            <CModal
                backdrop="static"
                visible={visibleView}
                onClose={() => setVisibleView(false)}
                aria-labelledby="LiveDemoExampleLabel"
                onIni className='assign-modal'
            >
                <div className="exam-detail-card">
                    <header className="exam-header">
                        <h1 className="exam-title">Exam Details</h1>
                        <button type="button" className="close-btn" aria-label="Close" onClick={() => { setVisibleView(false); setShowPassword(false); setShowReExamPassword(false) }} >&times;</button>
                    </header>
                    <section className="exam-info">
                        <div className="info-group">
                            <h2 className="group-title">General Information</h2>
                            <div className="info-item">
                                <span className="label">Mode:</span>
                                <span className="value">{selectedExam?.exam_mode === 1 ? "Offline" : selectedExam?.exam_mode === 2 ? "Online" : selectedExam?.exam_mode === 3 ? "Both" : "N/A"}</span>
                            </div>
                            <div className="info-item">
                                <span className="label">Name:</span>
                                <span className="value">{selectedExam?.ExamMaster.exam_name}</span>
                            </div>
                            <div className="info-item">
                                <span className="label">Pattern:</span>
                                <span className="value">{selectedExam?.ExamPattern.exam_pattern_name}</span>
                            </div>
                            <div className="info-item">
                                <span className="label">Description:</span>
                                <span className="value">{selectedExam?.ExamMaster.description}</span>
                            </div>
                        </div>
                        <div className="info-group">
                            <h2 className="group-title">Class & Division</h2>
                            <div className="info-item">
                                <span className="label">Class:</span>
                                <span className="value">{selectedExam?.InstituteGradeMaster.gradeName}</span>
                            </div>
                            <div className="info-item">
                                <span className="label">Division:</span>
                                <span className="value">{selectedExam?.ExamAssignDivisions.map(i => i.InstituteDivisionMaster.divisionName).join(', ')}</span>
                            </div>
                        </div>
                        <div className="info-group">
                            <h2 className="group-title">Subject</h2>
                            <div className="info-item">
                                <span className="label">{getSubjectNames(selectedExam?.ExamMaster).includes(",") ? "Subjects:" : "Subject:"}</span>
                                <span className="value">
                                    {getSubjectNames(selectedExam?.ExamMaster)}
                                    {/* {selectedExam?.ExamMaster?.is_competitive === 'Y'
                                                                                ? (selectedExam?.ExamMaster?.competitive_exam_type === "A" ? selectedExam?.ExamMaster?.subjectMaster?.subjectName : selectedExam?.ExamMaster?.instituteSubjectMaster?.subjectName)
                                                                                : (selectedExam?.ExamMaster?.syllabus_structure_type === "A" ? selectedExam?.ExamMaster?.subjectMaster?.subjectName : selectedExam?.ExamMaster?.instituteSubjectMaster?.subjectName)
                                                                            } */}
                                </span>
                            </div>
                        </div>
                        <div className="info-group">
                            <h2 className="group-title">Schedule</h2>
                            <div className="info-item">
                                <span className="label">Start Date:</span>
                                <span className="value">{moment(selectedExam?.start_date.split('T')[0]).format('DD/MM/YYYY')}</span>
                            </div>
                            <div className="info-item">
                                <span className="label">Start Time:</span>
                                <span className="value">{selectedExam?.start_time}</span>
                            </div>
                            <div className="info-item">
                                <span className="label">End Date:</span>
                                <span className="value">{moment(selectedExam?.end_date.split('T')[0]).format('DD/MM/YYYY')}</span>
                            </div>
                            <div className="info-item">
                                <span className="label">End Time:</span>
                                <span className="value">{selectedExam?.end_time}</span>
                            </div>
                        </div>
                        <div className="info-group">
                            <h2 className="group-title">Marks & Timing</h2>
                            <div className="info-item">
                                <span className="label">Total Time:</span>
                                <span className="value">{selectedExam?.exam_total_time} minutes</span>
                            </div>
                            <div className="info-item">
                                <span className="label">Ideal Time/Question:</span>
                                <span className="value">{selectedExam?.ideal_time_per_question} seconds</span>
                            </div>
                            <div className="info-item">
                                <span className="label">Negative Marks:</span>
                                <span className="value">{selectedExam?.negative_marks}</span>
                            </div>
                            <div className="info-item">
                                <span className="label">Positive Marks:</span>
                                <span className="value">{selectedExam?.positive_marks}</span>
                            </div>
                            <div className="info-item">
                                <span className="label">Passing Marks:</span>
                                <span className="value">{selectedExam?.passing_marks}</span>
                            </div>
                            <div className="info-item">
                                <span className="label">Total Marks:</span>
                                <span className="value">{selectedExam?.total_exam_marks}</span>
                            </div>
                            <div className="info-item">
                                <span className="label">Total Questions:</span>
                                <span className="value">{selectedExam?.total_questions}</span>
                            </div>
                        </div>
                        <div className="info-group">
                            <h2 className="group-title">Password</h2>
                            <div className="info-item">
                                <span className="label">Password:</span>
                                <span className="value">
                                    {showPassword ? selectedExam?.password : '••••••••'}
                                </span>
                                <button onClick={togglePasswordVisibility} className="eye-button">
                                    <i className={showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'}></i>
                                </button>
                            </div>
                            {selectedExam?.randomPassword && <div className="info-item">
                                <span className="label">Re Exam Password:</span>
                                <span className="value">
                                    {showReExamPassword ? selectedExam?.randomPassword : '••••••••'}
                                </span>
                                <button onClick={toggleReExamPasswordVisibility} className="eye-button">
                                    <i className={showReExamPassword ? 'fas fa-eye-slash' : 'fas fa-eye'}></i>
                                </button>
                            </div>}
                        </div>
                    </section>
                </div>
            </CModal>

            <CModal
                backdrop="static"
                visible={visibleResult}
                onClose={() => setVisibleResult(false)}
                aria-labelledby="LiveDemoExampleLabel"
                size="xl"
                className="assign-modal"
            >
                <GeneratePdf id="examReportContent" />
                <div id="examReportContent">
                    <div className="row">
                        <button
                            type="button"
                            className="btn-close"
                            aria-label="Close"
                            onClick={() => { setVisibleResult(false); setExamDetails([]); }}
                        ></button>
                    </div>

                    <div className="d-grid gap-2 mt-2">
                        <div className="report_block" id="examReportContent">
                            <div className="heading">
                                <div className="logo">
                                    <img src={examDetails?.sectionMasterDetails?.logoPath} alt="" />
                                </div>
                                <div className="text_center">
                                    <h6>{examDetails?.instituteMasterDetails?.instituteName}</h6>
                                    <h4>{examDetails?.sectionMasterDetails?.sectionName}</h4>
                                </div>
                                <div className="logo">
                                    <img src={examDetails?.instituteMasterDetails?.logoPath} alt="" />
                                </div>
                            </div>
                            <div className="report_code text_center">
                                <img src={separator_line} alt="" className="line" />
                                <span className="txt">Exam Result</span>
                            </div>

                            <div className="report_head">
                                <span>Board: {examDetails?.sectionMasterDetails?.boardMasterDetails?.boardName}</span>
                                <span>Medium: {examDetails?.sectionMasterDetails?.streamOrMediumMasterDetails?.streamName}</span>
                            </div>

                            {/* Scrollable Content */}
                            {/* <div style={{ maxHeight: '400px', overflowY: 'auto' }}> */}
                            <div className="analysis_report">
                                <span className="table_caption">Exam Details</span>
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Exam Name</th>
                                            <th>Start Date</th>
                                            <th>End Date</th>
                                            <th>Subject</th>
                                            <th>Class</th>
                                            <th>Division</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{examDetails?.exam_name}</td>
                                            <td>{examDetails?.startdate_24hrs?.split(" ")[0]}</td>
                                            <td>{examDetails?.enddate_24hrs?.split(" ")[0]}</td>
                                            <td>{getSubjectNames(examDetails?.ExamMaster)}</td>
                                            <td>{examDetails?.grade_name}</td>
                                            <td>{examDetails?.division_name?.join(",")}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div className="analysis_report">
                                <span className="table_caption">Exam Result</span>
                                {(isMulti.current === "Y" && (examType.current === "U" || examType.current === "M")) ?
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>Sr. No.</th>
                                                <th>Name of Student</th>
                                                <th>User ID</th>
                                                <th>Subject</th>
                                                <th>Correct Ans</th>
                                                <th>Wrong Ans</th>
                                                <th>Not Attempted</th>
                                                <th>Total Questions</th>
                                                <th>Obtained Marks</th>
                                                <th>Total Obtained Marks</th>
                                                <th>Total Marks</th>
                                                <th>%</th>
                                                <th>Remark</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {examDetails?.data?.map((student, studentIndex) => {
                                                const numberOfSubjects = student?.studentResult?.length;
                                                return student?.studentResult?.map((result, subjectIndex) => {
                                                    const totalQuestions = result.totalCorrect + result.totalWrong + result.totalNotAttempted;
                                                    return (
                                                        <tr key={`${studentIndex}-${subjectIndex}`}>
                                                            {subjectIndex === 0 ? (
                                                                <>
                                                                    <td rowSpan={numberOfSubjects}>{studentIndex + 1}</td>
                                                                    <td rowSpan={numberOfSubjects}>{student.studentName}</td>
                                                                    <td rowSpan={numberOfSubjects}>{student.std_id}</td>
                                                                </>
                                                            ) : null}

                                                            <td>{result.subjectName}</td>
                                                            <td>{result.totalCorrect}</td>
                                                            <td>{result.totalWrong}</td>
                                                            <td>{result.totalNotAttempted}</td>
                                                            <td>{totalQuestions}</td>
                                                            <td>{result.totalMarks}</td>

                                                            {subjectIndex === 0 && (
                                                                <>
                                                                    <td rowSpan={numberOfSubjects}>{student.totalMarks}</td>
                                                                    <td rowSpan={numberOfSubjects}>{student.totalExamMarks}</td>
                                                                    <td rowSpan={numberOfSubjects}>{parseFloat(student.percentage).toFixed(2)}</td>
                                                                    <td rowSpan={numberOfSubjects}>{student.passOrFail}</td>
                                                                </>
                                                            )}
                                                        </tr>
                                                    );
                                                });
                                            })}
                                        </tbody>
                                    </table>
                                    :
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>Sr. No.</th>
                                                <th>Name of Student</th>
                                                <th>User ID</th>
                                                <th>Correct Ans</th>
                                                <th>Wrong Ans</th>
                                                <th>Not Attempted</th>
                                                <th>Total Questions</th>
                                                <th>Obtained Marks</th>
                                                <th>Total Marks</th>
                                                <th>%</th>
                                                <th>Remark</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {examDetails?.data?.map((student, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{student.student_name}</td>
                                                        <td>{student.student_id}</td>
                                                        <td>{student.totalCorrect}</td>
                                                        <td>{student.totalWrong}</td>
                                                        <td>{student.totalNotAttempted}</td>
                                                        <td>{student.totalQuestions}</td>
                                                        <td>{student.totalMarks}</td>
                                                        <td>{student.totalExamMarks}</td>
                                                        <td>{student.percentage.toFixed(2) >= 0 ? student.percentage.toFixed(2) : 0}</td>
                                                        <td>{student.passOrFail}</td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                }
                            </div>
                            {/* </div> */}

                            <div className="report_footer">
                                <div className="section_incharge">
                                    <span>{examDetails?.sectionMasterDetails?.sectionInchargeName}</span>
                                    <span>Section Incharge Name</span>
                                </div>
                                <div className="institute_head">
                                    <span>{examDetails?.instituteMasterDetails?.inchargeName}</span>
                                    <span>Institute Head Name</span>
                                </div>
                                <div className="timestamp">
                                    <span>{getCurrentTime()}</span>
                                    <span>Time stamp of export</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </CModal>


            <CModal
                backdrop="static"
                visible={visibleLeaderBoard}
                onClose={() => setVisibleLeaderBoard(false)}
                aria-labelledby="LiveDemoExampleLabel"
                onIni className='assign-modal'
            >
                <div className="row">
                    <div className='popoup-title text-center w-100'><h3>Leaderboard</h3></div>
                    <button type="button" className="btn-close" aria-label="Close" onClick={() => setVisibleLeaderBoard(false)}></button>
                </div>

                <div class="cstm_student_table">
                    {
                        leaderBoardDetails?.length > 0 ?
                            leaderBoardDetails?.map((student, index) => {
                                return (
                                    <>
                                        <div class="item">
                                            <div class="title">
                                                <div class="img_block">
                                                    <img src={student.profilePicture ? student.profilePicture : VidyaUpasna} onerror="this.src='default_image.jpg'" alt="Student Image" />
                                                </div>
                                                <div class="title_block">
                                                    <span>{student.studentName}</span>
                                                </div>
                                            </div>
                                            <div class="tags">
                                                <span class="color_one">Rank: {student.rank}</span>
                                                <span class="color_two">Marks : {student.totalMarks}</span>
                                                <span class="color_three">Percentage : {student.percentage.toFixed(2) >= 0 ? student.percentage.toFixed(2) : 0}</span>
                                            </div>
                                        </div>
                                    </>
                                )
                            })
                            :
                            (<div className='item d-flex justify-content-center'>
                                <th colspan={"100%"} style={{ textAlign: 'center' }}>Leaderboard is not available</th>
                            </div>)
                    }
                </div>
            </CModal>
        </>
    )
};

export default ExamDetails;